<template>
  <div>
    <v-tooltip bottom :color="connected ? 'success' : 'red'">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          v-bind="attrs"
          :color="connected ? 'success' : 'error'"
          v-on="on"
          v-text="'mdi-checkbox-blank-circle'"
        />
        <b
          v-bind="attrs"
          class="pl-2"
          v-on="on"
          v-text="$t('adminGeneral.printer_status')"
        />
      </template>
      <span
        v-text="
          connected
            ? $t('adminGeneral.connected')
            : $t('adminGeneral.not_connected')
        "
      />
    </v-tooltip>
    <v-btn v-if="!connected" large icon @click="onConnect()">
      <v-icon v-text="'mdi-toggle-switch'" />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ConexionPrinter",
  data: () => ({
    // eslint-disable-next-line no-undef
    manager: new StarWebPrintExtManager(),
    url_connection: "http://localhost:8001/StarWebPRNT/SendDisplayExtMessage",
    connected: false,
  }),
  watch: {
    connected: function () {
      this.$store.dispatch("printer/setStatus", this.connected);
    },
  },
  mounted() {
    this.onConnect();
  },
  beforeDestroy() {
    this.onDisconnect();
  },
  methods: {
    onConnect: function () {
      const self = this;
      self.managerInit();

      if (self.manager.connect({ url: self.url_connection }) == false) {
        alert("Already connected or Now communicating");
      }
    },
    onDisconnect: function () {
      const self = this;
      self.manager.disconnect();
    },
    managerInit: function () {
      const self = this;

      self.manager.onReceive = function (response) {
        if (
          response.managerSuccess == "true" &&
          response.managerClaim == "true"
        ) {
          self.connected = true;
        } else if (response.managerClaim == "true") {
          // Keep Connecting
          self.connected = true;
        } else {
          self.connected = false;
        }
      };

      // eslint-disable-next-line no-unused-vars
      self.manager.onError = function (args) {};

      self.manager.onAccessoryDisconnect = function () {
        alert("onAccessoryDisconnect");
      };
      self.manager.onAccessoryConnectSuccess = function () {
        alert("onAccessoryConnectSuccess");
      };
      self.manager.onAccessoryConnectFailure = function () {
        alert("onAccessoryConnectFailure");
      };
      self.manager.onPrinterImpossible = function () {
        alert("onPrinterImpossible");
      };
      self.manager.onPrinterOnline = function () {
        alert("onPrinterOnline");
      };
      self.manager.onPrinterOffline = function () {
        alert("onPrinterOffline");
      };
      self.manager.onPrinterPaperReady = function () {
        alert("onPrinterPaperReady");
      };
      self.manager.onPrinterPaperNearEmpty = function () {
        alert("onPrinterPaperNearEmpty");
      };
      self.manager.onPrinterPaperEmpty = function () {
        alert("onPrinterPaperEmpty");
      };
      self.manager.onPrinterCoverOpen = function () {
        alert("onPrinterCoverOpen");
      };
      self.manager.onPrinterCoverClose = function () {
        alert("onPrinterCoverClose");
      };
      self.manager.onCashDrawerOpen = function () {
        alert("onCashDrawerOpen");
      };
      self.manager.onCashDrawerClose = function () {
        alert("onCashDrawerClose");
      };
      self.manager.onDisplayImpossible = function () {
        alert("onDisplayImpossible");
      };
      self.manager.onDisplayConnect = function () {
        alert("onDisplayConnect");
      };
      /* self.manager.onDisplayDisconnect = function () {
        alert("onDisplayDisconnect");
      }; */
      self.manager.onWrite = function () {
        alert("onWrite");
      };
      // eslint-disable-next-line no-unused-vars
      self.manager.onStatusUpdate = function (args) {
        alert("onStatusUpdate");
      };
    },
  },
};
</script>
